import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { Layout, Button, Spin, Alert } from 'antd';
import Translate from 'react-translate-component';
import { withAsyncActions } from 'react-async-client';
import qs from 'qs';
import * as yup from 'yup';

import { postEmailApproval } from 'actions/asyncActions';
import Text from 'components/common/form/Text';
import { GuestLanguage } from 'components/layout/guest/GuestFooter';
import EmailApprovalPerson from './EmailApprovalPerson';
import EmailApprovalProject from './EmailApprovalProject';

import withLimitCounter from 'components/hocs/withLimitCounter';
import withFormWrapper from 'components/hocs/withFormWrapper';

const TextWithLimitCounter = withLimitCounter(Text);

const validationSchema = yup.object().shape({
    comment: yup.string().required()
});

const stateToProps = (state, { location }) => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });

    return {
        initialStateValues: {
            token: params.authKey,
            status: params.action
        },
        type: params.type
    };
}

@connect(stateToProps)
@withAsyncActions({ formAction: postEmailApproval }, { autoReset: true })
@withFormWrapper({
    validationSchema,
    mapPropsToValues: props => props.initialStateValues
})
export default class EmailApproval extends Component {
    render() {
        const { handleSubmit, formAction: { meta } } = this.props;
        const { initialStateValues: { status, token }, type } = this.props;

        const isPeopleApproval = type === 'PplApproval';
        const isProjectApproval = type === 'PrjApproval';

        const form = token ? (
            <form className='email-approval-form'>
                <Field name='comment'
                    component={TextWithLimitCounter}
                    maxLength="511"
                    autoSize={{ minRows: 4, maxRows: 6 }}
                    placeholder='placeholders.comment' />
                { meta.error && <Alert message={<Translate content='alert.error' />} type='error' /> }
                { meta.success && <Alert message={<Translate content='alert.success' />} type='info' /> }
                <div className='text-right'>
                    <Button htmlType='submit' type='blue' onClick={handleSubmit} disabled={meta.success} loading={meta.pending}>
                        <Translate content={`button.${status || 'send'}`} />
                    </Button>
                </div>
            </form>
        ) : null;

        return token ? (
            <Layout className='email-approval-content guest-content'>
                <div className="guest-wrap">
                    <div className='email-approval-layout'>
                        <div>
                            <Spin spinning={meta.pending}>
                                <div className='email-approval-header'>
                                    <Translate content={`modal.${status}`} />
                                    <span className='pull-right'>
                                        <GuestLanguage />
                                    </span>
                                </div>
                                { isPeopleApproval && (
                                    <EmailApprovalPerson token={token} form={form} />
                                )}
                                { isProjectApproval && (
                                    <EmailApprovalProject token={token} form={form} />
                                )}
                            </Spin>
                        </div>
                    </div>
                </div>
            </Layout>
        ) : null;
    }
}
